<template>
    <ContentOrLoading>
        <div id="paso2_RA" class="container" v-if="zona">
            <div class="row mb-3">
                <div class="col-12 col-md-8">
                    <h2 class="m-0 h1 text-uppercase align-self-end">{{ $t(!event.reserva_instalaciones ? 'partido.elige_asientos' : 'partido.elige_reservas') }}</h2>
                    <div class="d-flex justify-content-between">
                        <h3 class="subtitle h3 light align-self-end">{{ $t('partido.varios_asientos') }}</h3>
                        <!-- Salida a la selección de zona. Debe estar disponible siempre que
                             se estén eligiendo asientos: antes dependía de `puede_cambiar`
                             (¿queda alguna zona o plaza con precios?), así que al entrar en una
                             región sin butacas el usuario se quedaba atrapado sin poder volver. -->
                        <button v-if="buttonCambiar" @click="reset" class="h6 button small-button mr-0" :disabled="paso3"><i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button>
                    </div>
                </div>          
            </div>
            <div v-if="abonadoId !== null && abonadoId !== undefined && plazasSeleccionadas.length > 0 && !minimoAsientosCumplido" class="alert alert-info" role="alert" data-test="annex-minimum-guidance">
                Debes seleccionar al menos {{ asientosMinimos }} butacas en total, incluyendo la del abonado.
            </div>
            <div class="row" v-if="zona.tipo_svg === 1">
                <div class="col-12 col-lg-4">
                    <div class="row">
                        <span class="col-12">
                            <div v-for="(plaza, index) in plazasSeleccionadas" class="lightgray-content p-2 mb-2" :key="index">
                                <div class="text-bold mb-2 d-flex justify-content-between">
                                    <div class="oswald d-flex">
                                        {{ (num = index + 1) }}. {{ getButacaName(plaza) }}
                                    </div>
                                    <span role="button" class="oswald" @click="clickZona(plaza)">
                                        <i class="fas fa-times mr-2"></i>
                                    </span>
                                </div>
                                <div class="form-group mb-1">
                                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                        <select name="precio" v-model="plaza.precioSeleccionado"
                                                :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                @change="actualizarEstadoPrecios"
                                        >
                                            <option :value="null" disabled hidden>{{ $t("partido.tipo_entrada") }} 
                                            </option>
                                            <option v-for="(precio, index) in plaza.precios" :key="index" :value="precio">
                                                {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                            </option>
                                        </select>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <b-button 
                                v-if="plazasSeleccionadas.length > 0" 
                                class="float-right"
                                :disabled="continuarConCompra || !precioSeleccionadoValido || !minimoAsientosCumplido"
                                @click="continuarCompra"
                            >
                                {{ $t('partido.continuar') }}
                            </b-button>
                        </span>
                    </div>
                </div>
                <div class="col-12 col-lg-8 order-first order-lg-last mb-3 mb-lg-0">
                    <div class="lightgray-content mapa-anexo">
                        <!-- Un único loader para toda la espera: las butacas y el SVG del recinto.
                             El mapa se monta en cuanto hay butacas (para no pintarlo sin datos) y
                             este overlay lo cubre hasta que avisa de que ya está pintado. -->
                        <div v-if="!mapa_pintado" class="mapa-anexo__loader">
                            <LoaderComponent/>
                        </div>
                        <RecintoAnexoComponent 
                            class="col-12"
                            :region_id="zona.id"
                            :plazas="plazas"
                            :plazasSeleccionadas="plazasSeleccionadas"
                            :continuarConCompra="continuarConCompra"
                            :tipo_svg="parseInt(zona.tipo_svg, 10)"
                            :sectores="sectores"
                            :disabled="continuarConCompra || !precioSeleccionadoValido"
                            @clickZona="clickZona"
                            @cargado="mapa_pintado = true"
                            v-if="butacas_resueltas"
                        />
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-12 col-lg-8">
                    <div v-if="!load_panzoom && svgGeneral" class="pb-3">
                        <div id="minimap" class="col-12 lightgray-content">
                            <SvgComponent
                                :place="event.place"
                                :sesion_id="sesion_id"
                                :zonas="zonas"
                                :zona_id="zona.id"
                                :svgGeneral="svgGeneral"
                                @cargado="selectSector"
                                @clickZona="cambiarSector"
                            />
                        </div>
                    </div>
                    <div class="lightgray-content mapa-anexo" id="seat-map">
                        <!-- Un único loader para toda la espera (butacas + SVG); ver arriba. -->
                        <div v-if="!mapa_pintado" class="mapa-anexo__loader">
                            <LoaderComponent/>
                        </div>
                        <RecintoAnexoComponent 
                            class="col-12"
                            :region_id="zona.id"
                            :plazas="plazas"
                            :plazasSeleccionadas="plazasSeleccionadas"
                            :continuarConCompra="continuarConCompra"
                            :tipo_svg="parseInt(zona.tipo_svg, 10)"
                            :sectores="sectores"
                            :precios="precios"
                            :disabled="continuarConCompra || !precioSeleccionadoValido"
                            @clickZona="clickZona"
                            @cargado="mapa_pintado = true"
                            v-if="butacas_resueltas"
                        />
                    </div>
                </div>
                <div class="col-12 col-lg-4 d-flex flex-column">
                    <div v-if="load_panzoom && svgGeneral" class="pb-3">
                        <div id="minimap" class="col-12 lightgray-content">
                            <SvgComponent
                                :place="event.place"
                                :sesion_id="sesion_id"
                                :zonas="zonas"
                                :zona_id="zona.id"
                                :svgGeneral="svgGeneral"
                                @cargado="selectSector"
                                @clickZona="cambiarSector"
                            />
                        </div>
                    </div>
                    <div class="d-flex flex-column justify-content-between" :style="dynamicStyle()">
                        <div class="overflow-auto" :class="[svgGeneral ? 'tusEntradasSvgGeneral' : 'tusEntradas']">
                            <div v-for="(plaza, index) in plazasSeleccionadas" class="lightgray-content p-2 mb-2" :key="index">
                                <div class="text-bold mb-2 d-flex justify-content-between">
                                    <div class="oswald">
                                        {{ (num = index + 1) }}.  <span v-html="getButacaName(plaza)"></span>                        
                                    </div>
                                    <span role="button" class="oswald" @click="clickZona(plaza)">
                                        <i class="fas fa-times mr-2"></i>
                                    </span>
                                </div>
                                <div class="form-group mb-1">
                                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                        <select 
                                            name="precio" 
                                            v-model="plaza.precioSeleccionado"
                                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                            :disabled="continuarConCompra || !preciosEnPlazas"
                                            @change="actualizarEstadoPrecios"
                                        >
                                            <option :value="null" disabled hidden>
                                                {{ $t("partido.tipo_entrada") }} 
                                            </option>
                                            <option v-for="(precio, index) in plaza.precios" :key="index" :value="precio">
                                                {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                            </option>
                                        </select>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <VisibilidadReducida tipo="butaca" :zona="zona" @aceptar="AceptarVisibilidadReducida"/>
                        <b-row v-if="teatro.carrito_varios_eventos && (abonadoId === null || abonadoId === undefined)">
                            <template v-if="!carrito || carrito.items_count == 0">
                                <b-col cols="9">
                                    <b-button 
                                        v-if="plazasSeleccionadas.length > 0 && confValida" 
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !precioSeleccionadoValido || bloquear || !minimoAsientosCumplido"
                                        @click="continuarCompra"
                                    >
                                        {{ $t('partido.continuar') }}
                                    </b-button>
                                </b-col>
                                <b-col cols="3">
                                    <b-button
                                        data-cy="add-cart-recinto-anexo"
                                        v-if="plazasSeleccionadas.length > 0 && confValida"
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !precioSeleccionadoValido  || bloquear || !minimoAsientosCumplido"
                                        @click="checkCarrito()"
                                    >
                                        <i class="fa fa-cart-plus" aria-hidden="true"></i>
                                    </b-button>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col cols="12">
                                    <b-button 
                                        v-if="plazasSeleccionadas.length > 0 && confValida" 
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !precioSeleccionadoValido  || bloquear || !minimoAsientosCumplido"
                                        @click="checkCarrito()"
                                    >
                                        {{ $t('carrito.añadir') }}
                                    </b-button>
                                </b-col>
                            </template>                            
                        </b-row>
                        <b-row v-else>
                            <b-col>
                                <b-button 
                                    v-if="plazasSeleccionadas.length > 0 && confValida" 
                                    class="btn btn-block mb-0"
                                    :disabled="continuarConCompra || !precioSeleccionadoValido || bloquear || !minimoAsientosCumplido"
                                    @click="continuarCompra"
                                >
                                    {{ $t('partido.continuar') }}
                                </b-button>
                            </b-col>   
                        </b-row>
                        <div 
                            v-if="plazasSeleccionadas.length > 0 && !confValida"
                            class="text-white bg-danger p-2 font-weight-bold rounded w-100 text-center"
                        >
                            ¡No puedes dejar huecos entre butacas!
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import RecintoAnexoComponent from '@/components/svg/RecintoAnexoComponent';
    import SvgComponent from '@/components/svg/SvgComponent';
    import VisibilidadReducida from '@/components/frontend/components/modals/VisibilidadReducida.vue';
    import comprobarButacasLeaflet from '@/mixins/comprobarButacasLeaflet.js';

    export default {
        props: ['zona', 'event', 'paso3', 'session_id', 'continuarConCompra', 'buttonCambiar', 'svgGeneral', 'zonas', 'sesion_id', 'abonadoId', 'datosAbonado', 'asientosMaximos', 'asientosMinimos', 'preciosAbonado', 'preciosAcompanante'],
        mixins: [comprobarButacasLeaflet],
        data() {
            return {
                svg_code: null,
                plazasSeleccionadas: [],
                sectores: null,
                precios: [],
                plazasConf: null,
                plazas: [],
                // Se pone a true cuando la petición de butacas termina (con datos o sin
                // ellos). Es lo que decide cuándo montar el mapa: sin este gate, el mapa
                // se montaba con la lista aún vacía, el SVG se pintaba sin datos y las
                // butacas que sí llegaban después se quedaban sin colorear; y si nunca
                // llegaba nada, `ContentOrLoading` dejaba su loader girando para siempre.
                butacas_resueltas: false,
                // El mapa avisa con `cargado` cuando ya ha pintado el SVG: hasta entonces
                // el overlay del loader cubre la zona del mapa (un sólo loader en total).
                mapa_pintado: false,
                bloquear: false, 
                precioSeleccionadoValido: false
            }
        },
        created() {
            this.getRecintoAnexo();
        },
        watch: {
            plazasSeleccionadas() {
                this.actualizarPreciosSeleccionados();
            },
            plazasConVisibilidadReducida(newVal) {
                if (newVal) {
                    this.$modal.show('visibilidad-reducida');
                }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            plazasConVisibilidadReducida() {
                return this.plazasSeleccionadas.some(plaza => plaza.visibilidad_reducida);
            },
            load_panzoom() {
                let load_panzoom = true

                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if(/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
            preciosEnPlazas() {
                return this.plazasSeleccionadas.every(plaza => plaza.precios);
            },
            precioSeleccionado() {
                return this.plazasSeleccionadas.some(plaza => plaza.precioSeleccionado);
            },
            minimoAsientosCumplido() {
                const minSeats = Number(this.asientosMinimos);
                return !Number.isFinite(minSeats) || minSeats <= 0 || this.plazasSeleccionadas.length >= minSeats;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivoOnline;
            },
        },
        methods: {
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }, 
            actualizarEstadoPrecios() {
                this.precioSeleccionadoValido = this.plazasSeleccionadas.length > 0 &&
                    this.plazasSeleccionadas.every(plaza => plaza.precioSeleccionado !== null);
            },
            preciosParaPlaza(plaza) {
                if (this.abonadoId !== null && this.abonadoId !== undefined) {
                    const priceList = this.plazasSeleccionadas.indexOf(plaza) === 0 ? this.preciosAbonado : this.preciosAcompanante;
                    return Array.isArray(priceList) ? priceList : [];
                }

                return Array.isArray(plaza?.precios) ? plaza.precios : [];
            },
            actualizarPreciosSeleccionados() {
                this.plazasSeleccionadas.forEach(plaza => {
                    const precios = this.preciosParaPlaza(plaza);
                    if (this.abonadoId !== null && this.abonadoId !== undefined) {
                        this.$set(plaza, 'precios', precios);
                    }

                    const precioActual = precios.find(precio => String(precio.id) === String(plaza.precioSeleccionado?.id));
                    this.$set(plaza, 'precioSeleccionado', precioActual || (precios.length === 1 ? precios[0] : null));
                });
                this.actualizarEstadoPrecios();
            },
            getRecintoAnexo() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        ...(this.abonadoId !== null && this.abonadoId !== undefined ? { abonado_id: this.abonadoId } : {})
                    },
                    evento_id: this.event.id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.sesion.zona.anexa.butacas'), params)
                    .then(({ data: { data } }) => {
                        this.plazas = data;
                        setTimeout(() => {
                            this.$scrollTo('#paso2_RA', 500)
                        }, 400);
                        this.setPlazasConf(this.plazas);

                        // El mapa se monta en cuanto la petición ha terminado, haya
                        // butacas o no: con la lista vacía el SVG debe verse igualmente
                        // (todo no disponible) en lugar de dejar el loader girando. Se
                        // marca en el propio `.then` —y no en un `.finally`— para que
                        // `plazas` y el flag cambien en el mismo tick y el mapa se monte
                        // ya con los datos, como hacía el antiguo `plazas.length > 0`.
                        this.butacas_resueltas = true;
                    })
                    .catch(error => {
                        console.error('Error al recuperar las butacas del recinto anexo', error);
                        this.butacas_resueltas = true;
                    });
            },
            clickZona(plazaSeleccionada) {
                if (this.continuarConCompra) {
                    return;
                }

                const plaza = this.plazas.find(item => item.id == plazaSeleccionada.id);
                if (!plaza) {
                    return;
                }

                const seleccionada = Boolean(plaza.seleccionada);
                const maxSeats = Number(this.asientosMaximos);
                if (!seleccionada && Number.isFinite(maxSeats) && maxSeats > 0 && this.plazasSeleccionadas.length >= maxSeats) {
                    this.$toast.error(this.$t('eventos.error_limite_asientos') + ' (Máx: ' + maxSeats + ')');
                    return;
                }

                plaza.seleccionada = !seleccionada;
                if (plaza.seleccionada) {
                    if (this.zona.tipo_svg === 1) {
                        document.getElementById('popover-' + plaza.id).classList.add('seleccionada');
                    }
                    this.plazasSeleccionadas.push(plazaSeleccionada);
                    if (this.abonadoId === null || this.abonadoId === undefined) {
                        this.plazasSeleccionadas.sort((a, b) => a.butaca - b.butaca);
                    }
                    this.actualizarPreciosSeleccionados();
                } else {
                    if (this.zona.tipo_svg === 1) {
                        document.getElementById('popover-' + plaza.id).classList.remove('seleccionada');
                    }
                    if (this.zona.tipo_svg === "2") {
                        const butacaElement = document.getElementById('butaca-' + plaza.svg_id);
                        if (butacaElement) {
                            butacaElement.setAttribute('seleccionado', 'false');
                            butacaElement.setAttribute('fill', '#0CBA31');
                        }
                    }

                    const index = this.plazasSeleccionadas.findIndex(item => item.id == plazaSeleccionada.id);
                    if (index !== -1) {
                        this.plazasSeleccionadas.splice(index, 1);
                        this.actualizarPreciosSeleccionados();
                    }
                }
            },
            reset() {
                this.$emit('reset', true);
            },
            continuarCompra() {
                if (!this.minimoAsientosCumplido || !this.precioSeleccionadoValido) {
                    return;
                }
                this.bloquear = true;

                let data = this.plazasSeleccionadas.map(plaza => {
                    return {
                        "butaca_id": plaza.id,
                        "precio_id": plaza.precioSeleccionado.id
                    }
                });

                let params = {
                    filters: {},
                    event_id: this.$route.params.event_id,
                    sesion_id: this.$route.params.sesion_id,
                    session_id: this.session_id,
                    data: data,
                    ...(this.datosAbonado && Object.keys(this.datosAbonado).length > 0 ? { datos_abonado: this.datosAbonado } : {})
                }
            
                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.bloquear-butacas'), params).then(({ data }) => {
                    sessionStorage.setItem('session_id', data.session_id);
                    this.$emit('setPlazas', this.plazasSeleccionadas);
                    this.$emit('goTo', data.session_id);
                    this.$emit('setCartId', data.cart_id);
                }).catch(error => {
                    this.$toast.error('Butaca/s ocupada/s');
                    this.$emit('cambiar-asiento', true);
                }).finally(() => {
                    this.bloquear = false;
                });
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            async crearCarrito() {
                const params = { filters: {}, uuid: localStorage.getItem('uuid') };

                return this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            setItemsCarrito() {            

                this.bloquear = true;
            
                const params = {
                    filters: {uuid: localStorage.getItem('uuid')},
                    cart_id: this.carrito?.id,
                    plazas: this.getPlazasFormatted(),
                    asientos: []
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('USUARIO_CARRITO_ACTIVO', {filters:{ uuid: localStorage.getItem('uuid')}});
                    this.$router.push({path: "/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.bloquear = false;
                });
            },
            getPlazasFormatted() {
                let plazas = [];

                this.plazasSeleccionadas.map(plaza => {
                    plazas.push({
                        precio: {
                            id: plaza.precioSeleccionado.id
                        },
                        id: plaza.id,
                        event_id:this.$route.params.event_id,
                        event_session_id: this.$route.params.sesion_id,
                        region_id: this.zona.id
                    })
                });

                return plazas;
            },
            getButacaName(plaza) {
                const nButaca = plaza.butaca;
                const nFila = plaza.fila;
                const visibilidad_reducida = plaza.visibilidad_reducida;
                const porcentaje_visibilidad = plaza.porcentaje_visibilidad;
                let name = '';

                if(this.sectores) {
                    const sector = this.sectores.find(sector => sector.id == plaza.sector);
                    if (sector) {
                        name += `Sector: ${sector.name} - `;
                    }
                }       

                if (!this.event.reserva_instalaciones) {
                    if (!nButaca && !nFila) {
                        name += `Plaza: ${plaza.numero}`;
                    } else {
                        name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                    }
                } else {
                    name += 'Reserva';
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getButacasLibresPrecio(precioId) {
                return this.plazas.filter(plaza => {
                    return plaza.disponible && plaza.precios.some(precio => precio.id == precioId);
                }).length;
            },
            selectSector() {
                setTimeout(() => {
                    const sectorSelected = document.querySelector(`#minimap [id="popover-${this.zona.id}"] path`);
                    if (sectorSelected) {
                        sectorSelected.setAttribute('fill', '#457ad1')
                    }
                }, 100);
            },
            cambiarSector(sector) {
                this.$emit('cambiarSector', sector);
            },
            dynamicStyle() {
                const seleccionValida = this.plazasSeleccionadas.length > 0 && this.confValida;
                const esAbonado = this.abonadoId !== null && this.abonadoId !== undefined;
                const accionesCarrito = this.teatro.carrito_varios_eventos && !esAbonado;
                const carritoVacio = !this.carrito || this.carrito.items_count == 0;
                const botonesVisibles = seleccionValida ? (accionesCarrito && carritoVacio ? 2 : 1) : 0;
                return {
                    height: botonesVisibles === 1 ? '100%' : '94.2%'
                }
            }
        },
        components: { RecintoAnexoComponent, SvgComponent, VisibilidadReducida }
    }
</script>

<style scoped>
.border-left {
    border-width: 3px !important;
}

/*
 * Mapa del recinto anexo + su loader único.
 * El loader va en un overlay (y no con `display: none`) porque Leaflet y el pan-zoom del
 * SVG necesitan dimensiones reales al montarse: ocultar el mapa lo dejaría mal encuadrado.
 */
.mapa-anexo {
    position: relative;
    min-height: 300px;
}

.mapa-anexo__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ededed;
    z-index: 5;
}

@media only screen and (min-width: 768px) {
    .tusEntradasSvgGeneral {
        height: 250px;
    }

    .tusEntradas {
        height: 480px;
    }

    .dropdown:hover .dropdown-menu {
        display: block;
        margin-top: 0;
    }
}
</style>